import { useCallback, useState } from 'react'

import { StateMachineData, StateMachineEdge, StateMachineNode, Selection } from '../ProgramStateMachine.types'

interface UseStateMachineProps {
  stateMachineData: StateMachineData | null
}

interface UseStateMachineReturn {
  stateMachineData: StateMachineData | null
  error: string | null
  selectedElement: StateMachineNode | StateMachineEdge | null
  handleSelectionChange: (selection: Selection) => void
  isLoading: boolean
  setError: (error: string | null) => void
  setIsLoading: (loading: boolean) => void
}

export function useStateMachine({ stateMachineData }: UseStateMachineProps): UseStateMachineReturn {
  const [selectedElement, setSelectedElement] = useState<StateMachineNode | StateMachineEdge | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleSelectionChange = useCallback((selection: Selection) => {
    const { nodes, edges } = selection

    // Prioritize node selection over edge selection
    if (nodes.length > 0) {
      setSelectedElement(nodes[0])
    } else if (edges.length > 0) {
      setSelectedElement(edges[0])
    } else {
      setSelectedElement(null)
    }
  }, [])

  return {
    stateMachineData,
    error,
    selectedElement,
    handleSelectionChange,
    isLoading,
    setError,
    setIsLoading
  }
}
